// extracted by mini-css-extract-plugin
module.exports = {"iconNew":"styles_iconNew__1i82F"};